import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import '../styles/TermsPage.css';

const TermsPage = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <div className="terms-container">
            <div className="terms-box">
                <button 
                    className="back-button" 
                    onClick={handleGoBack}
                    type="button"
                >
                    <IoArrowBack /> Back
                </button>
                
                <h2>Terms of Service</h2>
                <p className="effective-date">Effective date: {new Date().toLocaleDateString()}</p>

                <p>Welcome to Rasmoose! These Terms of Service govern your use of our platform. By creating an account or using our site, you agree to these terms.</p>

                <h3>1. Who Can Use Rasmoose</h3>
                <p>You must be:</p>
                <ul>
                    <li>At least 16 years old</li>
                    <li>Able to accept these terms and our Privacy Policy</li>
                </ul>

                <h3>2. User Accounts</h3>
                <p>You are responsible for:</p>
                <ul>
                    <li>Keeping your login credentials secure</li>
                    <li>All activity under your account</li>
                    <li>Providing accurate, non-offensive usernames</li>
                </ul>
                <p>You may sign in using email or Google. We reserve the right to suspend or delete accounts that violate these terms.</p>

                <h3>3. Access to Features</h3>
                <p>While all users can browse content, access to certain features such as posting reviews, participating in city chats, and receiving a "Verified Student" badge requires you to successfully verify your student status using a valid academic email address.</p>

                <h3>4. Content Guidelines</h3>
                <p>You may post reviews and public chat messages. You agree to NOT post:</p>
                <ul>
                    <li>Hate speech, discrimination, harassment</li>
                    <li>False information or impersonation</li>
                    <li>Spam or promotional content</li>
                </ul>
                <p>We reserve the right to remove content or ban users at our sole discretion.</p>

                <h3>5. Limitation of Liability</h3>
                <p>Rasmoose is a student-built MVP platform offered "as is". We do not guarantee uninterrupted access or data accuracy.</p>
                <p>We are not liable for:</p>
                <ul>
                    <li>User-generated content</li>
                    <li>Loss of data or damages resulting from use of the platform</li>
                </ul>

                <h3>6. Termination</h3>
                <p>You may delete your account at any time. We may terminate access if you violate our terms or abuse the platform.</p>

                <h3>7. Changes to Terms</h3>
                <p>We may update these terms from time to time. The latest version will be posted here.</p>

                <h3>8. Acknowledgements</h3>
                <p>Our student verification feature is proudly powered by the open-source <a href="https://github.com/JetBrains/swot" target="_blank" rel="noopener noreferrer">Swot</a> library by JetBrains. We are grateful to the open-source community for their contributions.</p>

                <h3>9. Third-Party Services</h3>
                <p>We use Umami, a privacy-first analytics platform, to collect aggregated and anonymized data about website usage (such as page views and device/browser type). Umami does <strong>not</strong> collect or store any personally identifiable information and does not use cookies. Data collected through Umami is solely used to help us understand usage patterns and improve the website. For more information, you can review Umami's privacy practices.</p>
                <p>We are not liable for any issues arising out of the use of third-party services like Umami. By using this website, you agree to the data practices outlined above.</p>
            </div>
        </div>
    );
};

export default TermsPage; 